import React from 'react';

/** define inline svg icons as react components * */
// the only changes necessary are that class => className, and xmlns namespaces are not allowed
// and properties such as fill-rule need to be camelCased



/*
  Freyja's guide on making the best SVGs!

  SVGs in react are slightly diffenrly formatted; as they are react components. To easily make a react SVG, copy the
  code and put it here: https://www.smooth-code.com/open-source/svgr/playground/

  Now with the new SVG code, you have a well formatted SVG! However, it's not perfect yet! The ideal SVG:
  1. Scales in size
  2. Inherits color

  To achieve this
  1. you want to use the "viewBox" rule (usually the original SVG code before you converted it will have this)
  2. To inherit colors you want to use the "currentColor" attribute on rules such as "fill"

  To test your work, all SVGs in this file are automatically imported and rendered on /dev (only viewable in a
  dev build)
*/



// Dealing with svg ids
// 1. Rename id is <mask> tags to something unique. For example change <mask id="mask-2"> to <mask id="search-svg-mask">
// 2. Rename the corrisponding mask rule. For example mask="url(#mask-2)" to mask="url(#search-svg-mask)"
// 3. Delete all other ids. For example <g id="fill-1"> to <g>

const HouseSvg = () => (
  <svg viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      {/* I think the following path just puts a background color in??? */}
      {/* <path fill="#EBEBEB" d="M-88-64h1440V958H-88z" /> */}
      <path
        d="M15.6 8a.4.4 0 00.284-.682L14.4 5.823V1.2a.4.4 0 00-.4-.4h-2.4a.4.4 0 00-.4.4v1.394L9.186.461c-.58-.619-1.798-.61-2.37.001l-6.7 6.859A.4.4 0 00.4 8h1.2V14.8A1.2 1.2 0 002.8 16h4a.4.4 0 00.4-.4v-4.4h1.6v4.4c0 .22.179.4.4.4h3.811c.668 0 1.388-.638 1.388-1.3V8h1.2zm-1.882-.683a.399.399 0 00-.118.283v7.1c0 .197-.342.5-.588.5H9.601v-4.4a.4.4 0 00-.4-.4H6.8a.4.4 0 00-.4.4v4.4H2.8a.4.4 0 01-.4-.4V7.6a.4.4 0 00-.4-.4h-.65l6.042-6.185c.264-.282.946-.287 1.21-.006l2.707 2.866A.4.4 0 0012 3.6v-2h1.6v4.388a.4.4 0 00.117.282l.923.93H14c-.11 0-.21.045-.282.117z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const PaperSvg = () => (
  <svg viewBox="0 0 12 16">
    <g fill="none" fillRule="evenodd">
      <path
        d="M2.382 6.819a.401.401 0 00.384.403h5.629a.403.403 0 100-.806h-5.61a.394.394 0 00-.403.403zm6.013 1.997h-5.61a.403.403 0 100 .807h5.61a.401.401 0 00.403-.384v-.02a.394.394 0 00-.403-.403zm0 2.401h-5.61a.403.403 0 100 .807h5.61a.401.401 0 00.403-.384v-.02a.394.394 0 00-.403-.403zm2.69-7.894L7.875.115A.384.384 0 007.588 0H1.594A1.59 1.59 0 000 1.594v12.812A1.59 1.59 0 001.594 16h8.011a1.59 1.59 0 001.595-1.594V3.61a.384.384 0 00-.116-.288zM7.991 1.364l1.844 1.844H7.992V1.364zm2.4 13.042a.813.813 0 01-.806.806H1.594a.813.813 0 01-.806-.806V1.614a.813.813 0 01.806-.807h5.61V3.61a.401.401 0 00.384.404h2.805v10.39z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const FileXLS = () => (
  <svg viewBox="0 0 112 160">
    <path
      d="M111.696 34.47A4 4 0 01112 36v108c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16C0 7.163 7.163 0 16 0h60a4 4 0 012.828 1.172l32 32A4 4 0 01108 40h-4v104a8 8 0 01-8 8H16a8 8 0 01-8-8V16a8 8 0 018-8h56v28a4 4 0 004 4h28zM80 13.656V32h18.343L80 13.657zM28.36 81.969l4.218-6.749a4 4 0 016.784 4.24l-6.285 10.056 6.815 10.904a4 4 0 01-6.784 4.24l-4.748-7.597-4.748 7.597a4 4 0 11-6.784-4.24l6.815-10.904-6.285-10.056a4 4 0 016.784-4.24l4.218 6.749zM54.4 77.34v21.2H63a4 4 0 110 8H50.4a4 4 0 01-4-4v-25.2a4 4 0 118 0zm26.14 7.236c.1.044.146.06.096.046a27.1 27.1 0 011.925.623c1.388.5 2.779 1.098 4.103 1.804 4.037 2.154 6.775 4.863 7.255 8.66.874 6.93-3.858 11.135-9.73 11.494-3.181.19-5.998-.344-8.396-1.37a14.341 14.341 0 01-1.996-1.039 8.925 8.925 0 01-.9-.636 4 4 0 115.085-6.176c.05.041.378.247.959.496 1.29.552 2.874.853 4.765.74 1.71-.105 2.491-.798 2.275-2.507-.064-.51-1.125-1.56-3.082-2.603a23.373 23.373 0 00-3.049-1.336 19.682 19.682 0 00-1.329-.435 8.96 8.96 0 01-1.188-.432 10.845 10.845 0 01-2.24-1.314c-2.166-1.653-3.57-4.047-3.631-7.066a10.24 10.24 0 0110.032-10.773 14.71 14.71 0 0110.395 3.108 4 4 0 01-4.958 6.28 6.71 6.71 0 00-4.83-1.41 4 4 0 01-.409.02 2.24 2.24 0 00-2.24 2.38l.008.21c.004.4.133.621.487.891.177.136.386.254.592.345z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);


const FilePDF = () => (
  <svg viewBox="0 0 112 160">
    <path
      d="M73.903 77.564v25.14a4.094 4.094 0 004.095 4.093 4.094 4.094 0 004.095-4.093v-8.575h6.435a4.094 4.094 0 100-8.185h-6.435v-4.482h8.58a4.094 4.094 0 100-8.186H77.998a4.289 4.289 0 00-4.095 4.288zm-10.53-.195c-5.654-5.067-13.844-4.093-14.624-3.898a4.035 4.035 0 00-3.51 4.093v25.14a4.347 4.347 0 003.51 4.093c.835.161 1.685.227 2.535.194a17.868 17.868 0 0012.09-4.092c2.34-1.949 5.07-5.847 5.07-12.668a15.956 15.956 0 00-5.07-12.862zm-5.46 19.294a8.368 8.368 0 01-4.68 1.948V81.657a7.403 7.403 0 017.02 7.795v.78a8.066 8.066 0 01-2.34 6.43zM28.08 73.47h-7.214a4.074 4.074 0 00-4.095 3.898v25.335a4.094 4.094 0 004.095 4.093 4.094 4.094 0 004.094-4.093v-6.431h2.925c3.067.138 6.07-.909 8.385-2.923a12.74 12.74 0 000-17.15 13.772 13.772 0 00-8.19-2.729zm2.535 13.837a3.901 3.901 0 01-2.535.78h-3.315v-6.626h3.51c.85-.041 1.685.237 2.34.78.585.389.78 1.363.78 2.533 0 1.169-.195 2.143-.78 2.533zm81.118-52.813a4.89 4.89 0 00-.78-1.365L78.778 1.17a3.14 3.14 0 00-1.365-.78 4.585 4.585 0 00-1.56-.39H15.99C7.177.043.043 7.172 0 15.98v128.04c.043 8.808 7.177 15.937 15.99 15.98h79.948c8.813-.043 15.947-7.172 15.99-15.98V36.053a2.065 2.065 0 00-.196-1.56zM79.948 13.837L98.083 31.96H79.948V13.837zm23.985 130.182a7.91 7.91 0 01-2.319 5.674 7.92 7.92 0 01-5.676 2.317H15.99a7.92 7.92 0 01-5.677-2.317 7.91 7.91 0 01-2.318-5.674V16.175a7.91 7.91 0 012.318-5.673 7.92 7.92 0 015.677-2.317h55.963v27.869a4.074 4.074 0 003.9 4.092h28.08V144.02z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const CirclePlus = () => (
  <svg viewBox="0 0 16 16">
    <path
      d="M8 16A8 8 0 118 0a8 8 0 010 16zm-.4-7.4v3.8c0 .22.224.4.5.4s.5-.18.5-.4V8.6h3.8c.22 0 .4-.224.4-.5s-.18-.5-.4-.5H8.6v-4c0-.22-.224-.4-.5-.4s-.5.18-.5.4v4h-4c-.22 0-.4.224-.4.5s.18.5.4.5h4z"
      fill="currentColor"
    />
  </svg>
);

const CirclePlusOutline = () => (
  <svg viewBox="0 0 34 34">
    <path
      d="M16.667 0c9.204 0 16.666 7.462 16.666 16.667 0 9.204-7.462 16.666-16.666 16.666C7.462 33.333 0 25.871 0 16.667 0 7.462 7.462 0 16.667 0zm0 1.667c-8.285 0-15 6.715-15 15 0 8.284 6.715 15 15 15 8.284 0 15-6.716 15-15 0-8.285-6.716-15-15-15zm0 5c.46 0 .833.373.833.833v8.333h8.333a.833.833 0 010 1.667H17.5v8.333a.833.833 0 11-1.667 0V17.5H7.5a.833.833 0 110-1.667h8.333V7.5c0-.46.373-.833.834-.833z"
      fill="currentColor"
    />
  </svg>
);

const CircleCross = () => (
  <svg viewBox="0 0 160 160">
    <path
      d="M90.343 96L62.06 67.716a4 4 0 115.657-5.657L96 90.343l28.284-28.284a4 4 0 115.657 5.657L101.657 96l28.284 28.284a4 4 0 11-5.657 5.657L96 101.657 67.716 129.94a4 4 0 11-5.657-5.657L90.343 96zM96 176c-44.183 0-80-35.817-80-80s35.817-80 80-80 80 35.817 80 80-35.817 80-80 80zm0-8c39.765 0 72-32.235 72-72s-32.235-72-72-72-72 32.235-72 72 32.235 72 72 72z"
      fill="currentColor"
      transform="translate(-16 -16)"
      fillRule="evenodd"
    />
  </svg>
);

const ChevronDown = () => (
  <svg viewBox="0 0 83 45" focusable="false">
    <path
      d="M6.1 1.049a3.578 3.578 0 00-5.048-.013 3.551 3.551 0 00-.013 5.033l37.545 37.62a4.472 4.472 0 006.31.016l.037-.037L81.977 6.052a3.551 3.551 0 00-.046-5.033 3.578 3.578 0 00-5.048.047L41.734 36.754 6.101 1.05z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const ChevronLargeUp = () => (
  <svg viewBox="0 0 192 192">
    <path
      d="M168.543514,137.245134 L96.3399096,64.7014968 L23.9233154,137.245134 C22.9721405,138.506597 21.4233902,139.162402 19.8604638,138.965513 C18.2975374,138.768624 16.9578806,137.748953 16.3461291,136.290601 C15.7343776,134.832248 15.943471,133.156772 16.8946459,131.895308 C17.1076359,131.681315 17.3206259,131.253329 17.7466059,131.039336 L93.1450599,55.2858035 C93.9639735,54.4625437 95.0749513,54 96.2334146,54 C97.391878,54 98.5028558,54.4625437 99.3217694,55.2858035 L174.720223,131.039336 C175.539624,131.862106 176,132.978316 176,134.142235 C176,135.306154 175.539624,136.422364 174.720223,137.245134 C174.021252,138.171586 172.888147,138.659489 171.738364,138.529092 C170.541092,138.571519 169.381381,138.10545 168.543514,137.245134 Z"
      fill="currentColor"
    />
  </svg>
);

const ChevronLargeDown = () => (
  <svg viewBox="0 0 192 192">
    <g transform="translate(96.000000, 96.500000) scale(1, -1) translate(-96.000000, -96.500000) ">
      <path
        d="M168.543514,137.245134 L96.3399096,64.7014968 L23.9233154,137.245134 C22.9721405,138.506597 21.4233902,139.162402 19.8604638,138.965513 C18.2975374,138.768624 16.9578806,137.748953 16.3461291,136.290601 C15.7343776,134.832248 15.943471,133.156772 16.8946459,131.895308 C17.1076359,131.681315 17.3206259,131.253329 17.7466059,131.039336 L93.1450599,55.2858035 C93.9639735,54.4625437 95.0749513,54 96.2334146,54 C97.391878,54 98.5028558,54.4625437 99.3217694,55.2858035 L174.720223,131.039336 C175.539624,131.862106 176,132.978316 176,134.142235 C176,135.306154 175.539624,136.422364 174.720223,137.245134 C174.021252,138.171586 172.888147,138.659489 171.738364,138.529092 C170.541092,138.571519 169.381381,138.10545 168.543514,137.245134 Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const ChevronUp = () => (
  <svg viewBox="0 0 83 45" focusable="false">
    <path
      d="M6.1 43.951a3.578 3.578 0 01-5.048.013 3.551 3.551 0 01-.013-5.033l37.545-37.62a4.472 4.472 0 016.31-.016l.037.037 37.046 37.616a3.551 3.551 0 01-.046 5.033 3.578 3.578 0 01-5.048-.047L41.734 8.246 6.101 43.95z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const ChevronIconLeft = () => (
  <svg viewBox="0 0 10 18">
    <g fill="none" fillRule="evenodd">
      <path
        d="M9.782 16.687c.29.29.291.761.002 1.052a.74.74 0 01-1.048.003L.898 9.92a.932.932 0 01-.003-1.315l.007-.007L8.74.88a.74.74 0 011.049.01.745.745 0 01-.01 1.051L2.343 9.264l7.439 7.423z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const DoubleChevronIconLeft = () => (
  <svg viewBox="0 0 12 11">
    <path
      d="M11.494 9.612L7.03 5.158 11.49.765a.447.447 0 00.007-.631.444.444 0 00-.63-.006l-4.702 4.63-.004.005a.559.559 0 00.002.79l4.702 4.692a.444.444 0 00.63-.002.447.447 0 00-.002-.63zm-5.625 0L1.406 5.158 5.866.765a.447.447 0 00.007-.631.444.444 0 00-.63-.006L.541 4.758l-.004.005a.559.559 0 00.002.79l4.702 4.692a.444.444 0 00.63-.002.447.447 0 00-.002-.63z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </svg>
);


const ChevronIconRight = () => (
  <svg viewBox="0 0 10 18">
    <g fill="none" fillRule="evenodd">
      <path
        d="M.843 16.687a.745.745 0 00-.002 1.052.74.74 0 001.048.003L9.727 9.92a.932.932 0 00.003-1.315l-.007-.007L1.886.88A.74.74 0 00.837.89a.745.745 0 00.01 1.051l7.435 7.323-7.439 7.423z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const DoubleChevronIconRight = () => (
  <svg viewBox="0 0 12 11">
    <path
      d="M.506 9.612L4.97 5.158.51.765A.447.447 0 01.501.134a.444.444 0 01.63-.006l4.702 4.63.004.005a.559.559 0 01-.002.79l-4.702 4.692a.444.444 0 01-.63-.002.447.447 0 01.002-.63zm5.625 0l4.463-4.454L6.134.765a.447.447 0 01-.007-.631.444.444 0 01.63-.006l4.702 4.63.004.005a.559.559 0 01-.002.79L6.76 10.244a.444.444 0 01-.63-.002.447.447 0 01.002-.63z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </svg>
);

const ChevronFilledDown = () => (
  <svg viewBox="0 0 192 192">
    <path
      d="M98.551 134.885l92-91.385c2.414-2.399.704-6.5-2.711-6.5H3.84c-3.415 0-5.125 4.101-2.71 6.5l91.999 91.385a3.852 3.852 0 005.421 0z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const ChevronFilledUp = () => (
  <svg viewBox="0 0 192 192">
    <path
      d="M98.551 37.615l92 91.385c2.414 2.399.704 6.5-2.711 6.5H3.84c-3.415 0-5.125-4.101-2.71-6.5L93.13 37.615a3.852 3.852 0 015.421 0z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const ChevronFilledRight = () => (
  <svg viewBox="0 0 192 192">
    <path
      d="M98.7108451,144.9425 L190.710845,53.5575 C193.124845,51.1585 191.414845,47.0575 187.999845,47.0575 L3.99984511,47.0575 C0.584845112,47.0575 -1.12515489,51.1585 1.28984511,53.5575 L93.2888451,144.9425 L98.7108451,144.9425 Z"
      transform="translate(96.000000, 96.000000) rotate(-90.000000) translate(-96.000000, -96.000000) "
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const ChevronFilledLeft = () => (
  <svg viewBox="0 0 192 192">
    <path
      d="M98.7108451,144.9425 L190.710845,53.5575 C193.124845,51.1585 191.414845,47.0575 187.999845,47.0575 L3.99984511,47.0575 C0.584845112,47.0575 -1.12515489,51.1585 1.28984511,53.5575 L93.2888451,144.9425 L98.7108451,144.9425 Z"
      transform="translate(96.000000, 96.000000) rotate(90.000000) translate(-96.000000, -96.000000) "
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const VodafoneLogo = () => (
  <svg viewBox="0 0 28 28">
    <g fill="none" fillRule="evenodd">
      <path
        d="M27.333 14c0 7.364-5.97 13.333-13.333 13.333C6.636 27.333.667 21.363.667 14 .667 6.636 6.637.667 14 .667c7.364 0 13.333 5.97 13.333 13.333"
        fill="currentcolor"
      />
      <path
        d="M14.152 21.333c-3.66.012-7.469-3.1-7.485-8.096-.011-3.305 1.778-6.486 4.066-8.373 2.232-1.84 5.289-3.021 8.061-3.03.357-.002.73.028.959.105-2.424.5-4.354 2.748-4.345 5.298 0 .084.008.174.016.216 4.057.984 5.898 3.422 5.91 6.796.01 3.373-2.663 7.07-7.182 7.084"
        fill="#FFF"
      />
    </g>
  </svg>
);

const SearchMagnifier = () => (
  <svg viewBox="0 0 14 14">
    <g fill="none" fillRule="evenodd">
      <path
        d="M8.763 8.292l4.473 4.472a.333.333 0 01-.472.472L8.292 8.763a5 5 0 11.471-.471zM5 9.333A4.333 4.333 0 105 .667a4.333 4.333 0 000 8.666z"
        fill="currentColor"
        transform="translate(.333 .333)"
      />
    </g>
  </svg>
);

const SilhouetteAvatar = () => (
  <svg viewBox="0 0 17 18">
    <g fill="none" fillRule="evenodd">
      <path
        d="M7.839 10.131c-3.32.15-6.077 2.915-6.77 7.592a.5.5 0 01-.989-.146c.617-4.163 2.796-7.015 5.634-8.036a5.012 5.012 0 114.771-.013c2.826 1.007 4.977 3.858 5.597 8.049a.5.5 0 01-.99.146c-.697-4.714-3.411-7.465-6.723-7.593a5.092 5.092 0 01-.53.001zm.006-1a7.384 7.384 0 01.511-.002 4.013 4.013 0 10-.511.001z"
        fill="currentColor"
        transform="translate(.875 -.125)"
      />
    </g>
  </svg>
);

const SilhouetteAvatarWithAFriend = () => (
  <svg viewBox="0 0 144 112">
    <path
      d="M77.299 80.47C69.909 69.96 59.647 64.06 48 64.06c-19.759 0-35.524 16.958-40.053 44.587a4 4 0 01-7.894-1.294C3.927 83.72 15.618 66.438 31.563 59.46 22.24 53.87 16 43.663 16 32 16 14.327 30.327 0 48 0c17.673 0 32 14.327 32 32 0 11.665-6.241 21.871-15.566 27.463 5.931 2.597 11.275 6.622 15.846 11.869 3.657-5.326 8.248-9.404 13.48-12.01C87.84 54.95 84 47.923 84 40c0-13.255 10.745-24 24-24s24 10.745 24 24c0 7.92-3.837 14.945-9.753 19.316 10.965 5.469 18.954 17.376 21.695 33.274a4 4 0 11-7.884 1.36C132.848 75.326 121.818 64 108 64c-9.268 0-17.36 5.08-22.612 14.21 5.05 7.969 8.7 17.828 10.559 29.141a4 4 0 01-7.894 1.298c-1.822-11.086-5.452-20.456-10.422-27.7a3.995 3.995 0 01-.332-.48zM48 56c13.255 0 24-10.745 24-24S61.255 8 48 8 24 18.745 24 32s10.745 24 24 24zm60 0c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const WarningCircle = () => (
  <svg viewBox="0 0 14 14">
    <g fill="none" fillRule="evenodd">
      <path
        d="M7 13.667A6.667 6.667 0 117 .333a6.667 6.667 0 010 13.334zM7 9c.368 0 .667-.235.667-.526V3.61c0-.29-.299-.526-.667-.526-.368 0-.667.236-.667.526v4.865c0 .29.299.526.667.526zm0 2.333A.667.667 0 107 10a.667.667 0 000 1.333z"
        fill="currentColor"
      />
      <path d="M-1-1h16v16H-1z" />
    </g>
  </svg>
);

const CrossSvg = () => (
  <svg viewBox="0 0 18 16" focusable="false">
    <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="square">
      <path d="M1 0l15.879 15.879M16.879 0L1 15.879" />
    </g>
  </svg>
);

const TickSvg = () => (
  <svg viewBox="0 0 22 16">
    <path
      d="M6.485 12.89L19.105.27a.667.667 0 01.943.943L6.956 14.305a.667.667 0 01-.942 0L.195 8.486a.667.667 0 11.943-.942l5.347 5.347z"
      fill="currentColor"
      transform="translate(.833 .833)"
      fillRule="evenodd"
    />
  </svg>
);

const CalenderSvg = () => (
  <svg viewBox="0 0 18 20" focusable="false">
    <path
      d="M1 6h16V4a1 1 0 00-1-1h-3v.5a.5.5 0 11-1 0V3H6v.5a.5.5 0 01-1 0V3H2a1 1 0 00-1 1v2zm0 1v11a1 1 0 001 1h14a1 1 0 001-1V7H1zm5-5h6V.5a.5.5 0 111 0V2h3a2 2 0 012 2v14a2 2 0 01-2 2H2a2 2 0 01-2-2V4a2 2 0 012-2h3V.5a.5.5 0 011 0V2z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const ClockSvg = () => (
  <svg viewBox="0 0 20 20">
    <path
      d="M10.5 9.5h6a.5.5 0 110 1H10a.5.5 0 01-.5-.5V3.5a.5.5 0 011 0v6zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-1a9 9 0 100-18 9 9 0 000 18z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const ClockLoadingSvg = () => (
  <svg viewBox="0 0 160 170">
    <path
      d="M24 137.124v27.966a4 4 0 11-8 0V127a4 4 0 014-4h37.82a4 4 0 110 8H29.185c28.123 28.03 73.642 28 101.728-.088 28.116-28.118 28.116-73.706 0-101.824-28.115-28.117-73.7-28.117-101.817 0-19.252 19.253-25.805 47.366-17.68 72.848a4 4 0 01-7.622 2.43C-5.231 76.06 2.05 44.82 23.44 23.43c31.24-31.241 81.89-31.241 113.13 0 31.24 31.242 31.24 81.896 0 113.138-31.054 31.055-81.288 31.24-112.57.555zM76.01 84h48a4 4 0 110 8h-52a4 4 0 01-4-4V36a4 4 0 118 0v48z"
      fillRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

const WarningTriangle = () => (
  <svg viewBox="0 0 160 152">
    <path
      d="M137.23 152H22.77C2.998 152-5.8 135.782 4.057 118.368l57.23-105.13.054-.097c10.013-17.238 27.56-17.54 37.382.097l57.205 105.102c9.86 17.478 1.095 33.66-18.698 33.66zM11.051 122.25C4.116 134.505 9.266 144 22.77 144h114.46c13.531 0 18.657-9.475 11.718-21.752l-.031-.056L91.715 17.096c-6.718-12.062-16.476-11.91-23.43.017L11.052 122.25zM80 132a8 8 0 110-16 8 8 0 010 16zm0-28c-4.418 0-8-2.826-8-6.311V39.31C72 35.826 75.582 33 80 33s8 2.826 8 6.311V97.69c0 3.485-3.582 6.311-8 6.311z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const WarningTriangleFilled = () => (
  <svg viewBox="0 0 34 32">
    <path
      d="M20.9 3.091l11.918 21.897c2.054 3.64.228 7.012-3.895 7.012H5.077c-4.12 0-5.952-3.379-3.898-7.007L13.1 3.091l.012-.02c2.086-3.591 5.741-3.654 7.788.02zM17 25.125a1.667 1.667 0 100 3.333 1.667 1.667 0 000-3.333zm0-17.917c-.92 0-1.667.612-1.667 1.367v12.267c0 .754.747 1.366 1.667 1.366s1.667-.612 1.667-1.366V8.575c0-.755-.747-1.367-1.667-1.367z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const ExpandAll = () => (
  <svg viewBox="0 0 20 20">
    <g fill="currentColor" fillRule="evenodd">
      <path d="M10.098 9.904c.2.2.2.523 0 .722l-7.746 7.746 3.575-.132a.51.51 0 01.518.4l.011.091a.51.51 0 01-.491.53l-4.875.18a.521.521 0 01-.29-.078.508.508 0 01-.09-.071l.051.045a.514.514 0 01-.034-.03l-.017-.015a.52.52 0 01-.138-.255.506.506 0 01-.01-.125l.002.08a.513.513 0 01-.003-.051v-.029l.18-4.875a.51.51 0 111.021.038L1.63 17.65l7.747-7.746a.51.51 0 01.652-.06z" />
      <path d="M10.098 10.098c.2-.2.2-.522 0-.722L2.352 1.63l3.575.132a.51.51 0 00.518-.4l.011-.091a.51.51 0 00-.491-.53L1.09.562A.521.521 0 00.8.64.508.508 0 00.71.71L.761.666a.514.514 0 00-.034.029L.71.71a.52.52 0 00-.138.255.506.506 0 00-.01.125l.002-.08a.513.513 0 00-.003.052v.028l.18 4.875a.51.51 0 101.021-.038L1.63 2.352l7.747 7.746a.51.51 0 00.652.06z" />
      <path d="M9.902 9.904c.2-.2.522-.2.722 0l7.746 7.746-.132-3.575a.51.51 0 01.4-.517l.091-.012a.51.51 0 01.53.491l.18 4.875a.521.521 0 01-.078.29.508.508 0 01-.071.09l.044-.051a.514.514 0 01-.029.035l-.015.016a.52.52 0 01-.255.138.506.506 0 01-.125.011l.08-.003a.513.513 0 01-.052.003h-.028l-4.875-.18a.51.51 0 11.038-1.021l3.575.133-7.746-7.747a.51.51 0 01-.06-.651z" />
      <path d="M9.902 10.098c.2.2.522.2.722 0l7.746-7.746-.132 3.575a.51.51 0 00.4.518l.091.011a.51.51 0 00.53-.491l.18-4.875A.521.521 0 0019.36.8a.508.508 0 00-.071-.09l.044.051a.514.514 0 00-.029-.034L19.29.71a.52.52 0 00-.255-.138.506.506 0 00-.125-.01l.08.002a.513.513 0 00-.052-.003h-.028l-4.875.18a.51.51 0 10.038 1.021l3.575-.133-7.746 7.747a.51.51 0 00-.06.652z" />
    </g>
  </svg>
);

// DMB: WARNING! This is a temporary icon until we have a design for collapse all
const CollapseAll = () => (
  <svg viewBox="0 0 20 20">
    <g fill="currentColor" fillRule="evenodd">
      <path d="M19.23.713c.195.195.216.491.046.661l-6.569 6.568 3.09.007a.5.5 0 01.472.364l.016.091a.413.413 0 01-.418.453l-4.104-.009a.5.5 0 01-.552-.138.49.49 0 01-.155-.352l-.01-4.322c-.001-.25.202-.437.452-.418.25.019.455.237.455.487l.008 3.169L18.57.667c.15-.15.402-.152.593-.013zM19.133 19.409c.196-.195.216-.492.046-.662l-6.588-6.587 3.179-.055a.527.527 0 00.484-.376l.017-.093a.405.405 0 00-.417-.454l-4.246.072a.513.513 0 00-.487.153.512.512 0 00-.158.355l-.076 4.388a.405.405 0 00.453.417.526.526 0 00.469-.501l.056-3.218 6.607 6.606c.151.152.402.152.593.013zM.62.874c.194-.195.487-.219.653-.053l6.408 6.41.048-3.058a.511.511 0 01.366-.47l.09-.018a.396.396 0 01.442.408l-.062 4.061c.068.165.02.38-.133.533a.497.497 0 01-.36.168l-4.274.067a.396.396 0 01-.407-.442.51.51 0 01.487-.456l3.133-.05L.566 1.529C.419 1.381.421 1.133.56.943zM.328 19.563c.195.195.494.213.668.04l6.716-6.716.034 3.222a.524.524 0 00.377.486l.094.018a.416.416 0 00.462-.426l-.043-4.31a.512.512 0 00-.151-.479.51.51 0 00-.358-.157l-4.44-.046a.416.416 0 00-.425.462.523.523 0 00.504.471l3.256.035-6.733 6.733c-.155.154-.158.407-.02.599z" />
    </g>
  </svg>
);

const InformationCircle = () => (
  <svg viewBox="0 0 160 160">
    <path
      d="M88.058 112.038h-4.03V68.106a4.01 4.01 0 00-3.836-4.03h-8.25a4.048 4.048 0 00-4.028 4.03 3.933 3.933 0 004.028 4.028h4.03v39.904h-4.03a4.048 4.048 0 00-4.028 4.03 3.933 3.933 0 004.028 4.028h15.924a4.01 4.01 0 004.028-3.837v-.192a3.837 3.837 0 00-3.645-4.029h-.191zM80 0C35.817 0 0 35.817 0 80s35.817 80 80 80 80-35.817 80-80C159.895 35.861 124.139.105 80 0zm0 151.942c-39.733 0-71.942-32.21-71.942-71.942C8.058 40.267 40.268 8.058 80 8.058c39.733 0 71.942 32.21 71.942 71.942-.01 39.728-32.214 71.932-71.942 71.942zm-1.918-100.91a5.947 5.947 0 10-5.948-5.948 5.755 5.755 0 005.756 5.947h.192z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const LoadingSpinnerSVG = () => (
  <svg viewBox="0 0 192 192">
    <g fill="currentColor" fillRule="evenodd">
      <rect
        transform="scale(1 -1) rotate(-60 -10.277 0)"
        x={46}
        y={40.038}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="scale(1 -1) rotate(-30 -202.277 0)"
        x={24.038}
        y={62}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="matrix(1 0 0 -1 0 192)"
        x={16}
        y={92}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="scale(1 -1) rotate(30 514.277 0)"
        x={24.038}
        y={122}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="scale(1 -1) rotate(60 322.277 0)"
        x={46}
        y={143.962}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="rotate(-90 96 156)"
        x={76}
        y={152}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="rotate(-120 126 147.962)"
        x={106}
        y={143.962}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="rotate(-150 147.962 126)"
        x={127.962}
        y={122}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="rotate(-180 156 96)"
        x={136}
        y={92}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="rotate(150 147.962 66)"
        x={127.962}
        y={62}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="rotate(120 126 44.038)"
        x={106}
        y={40.038}
        width={40}
        height={8}
        rx={4}
      />
      <rect
        transform="rotate(90 96 36)"
        x={76}
        y={32}
        width={40}
        height={8}
        rx={4}
      />
    </g>
  </svg>
);


const CheckBoxUnchecked = () => (
  <svg viewBox="0 0 16 16">
    <rect
      x={732.5}
      y={644.5}
      width={15}
      height={15}
      rx={4}
      transform="translate(-732 -644)"
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

const CheckBoxChecked = () => (
  <svg viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <rect stroke="currentColor" x={0.5} y={0.5} width={15} height={15} rx={4} />
      <rect fill="currentColor" width={16} height={16} rx={3} />
      <path
        d="M6.526 10.342l5.045-5.161a.6.6 0 01.858.838l-5.474 5.6a.6.6 0 01-.858 0L3.571 9.035a.6.6 0 11.858-.839l2.097 2.146z"
        fill="#FFF"
      />
      <rect stroke="currentColor" x={0.5} y={0.5} width={15} height={15} rx={4} />
    </g>
  </svg>
);

const DownloadIcon = () => (
  <svg viewBox="0 0 192 192">
    <path
      d="M172 112a4 4 0 014 4v20c0 13.255-10.745 24-24 24H40c-13.255 0-24-10.745-24-24v-20a4 4 0 118 0v20c0 8.837 7.163 16 16 16h112c8.837 0 16-7.163 16-16v-20a4 4 0 014-4zM96 32a4 4 0 014 4v85.813l19.069-20.535a4 4 0 015.488-.354l.165.145a4 4 0 01.21 5.653l-26 28a4.066 4.066 0 01-.55.493l-.08.057-.087.06-.067.043a3.834 3.834 0 01-1 .458 4.393 4.393 0 01-.412.1l-.042.007c-.051.009-.103.017-.154.024l-.07.009a3.41 3.41 0 01-.212.019A3.998 3.998 0 0196 136l.129-.002-.048.001L96 136a4.077 4.077 0 01-.694-.06l-.042-.008a3.442 3.442 0 01-.413-.1 3.451 3.451 0 01-.364-.128 2.893 2.893 0 01-.184-.081 3.879 3.879 0 01-.451-.247l-.067-.044a2.24 2.24 0 01-.087-.06l-.079-.058a3.972 3.972 0 01-.55-.492l.104.107a4.026 4.026 0 01-.083-.085l-.021-.022-26-28a4 4 0 015.862-5.444L92 121.813V36a4 4 0 013.8-3.995z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const Pencil = () => (
  <svg viewBox="0 0 160 160">
    <path
      d="M4 160c-1 0-2.1-.4-2.8-1.2-1-1-1.4-2.4-1.1-3.8l9.5-38c.2-.7.5-1.3 1.1-1.9l92.4-92.4c.1-.1.1-.2.2-.3L118.8 7c9.4-9.3 24.7-9.3 34.2 0 4.4 4.4 6.8 10.3 6.8 16.6 0 6.5-2.6 12.9-7.2 17.5l-15.4 15.4-.2.2-92 92.6c-.5.5-1.2.9-1.9 1.1l-38 9.5c-.5.1-.8.1-1.1.1zm13.1-40l-7.6 30.5 30.5-7.6 88.7-89.2L106.2 31l-89.1 89zm94.7-94.7L134.3 48l12.6-12.6c3.1-3.1 4.9-7.4 4.9-11.8 0-4.2-1.6-8.1-4.5-11-6.3-6.2-16.6-6.2-22.9 0l-12.6 12.7z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const WritingPencil = () => (
  <svg viewBox="0 0 152 160">
    <path
      d="M128 49.737V144c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V40c0-8.837 7.163-16 16-16h86.186l18.708-18.671.023-.023c7.126-6.998 18.559-6.95 25.626.107 7.068 7.057 7.132 18.489.116 25.655L128 49.738zm-8 8.005l-63.05 63.086a4 4 0 01-1.86 1.052l-26.82 6.71c-2.92.731-5.57-1.904-4.856-4.829l6.56-26.87a4 4 0 011.06-1.882L94.17 32H16a8 8 0 00-8 8v104a8 8 0 008 8h96a8 8 0 008-8V57.742zM37.48 99.879l-4.723 19.342 19.317-4.832 88.898-88.947c3.917-4.002 3.881-10.412-.081-14.368-3.96-3.953-10.362-3.983-14.358-.07L37.48 99.879z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const Briefcase = () => (
  <svg viewBox="0 0 160 136">
    <path
      d="M48 24v-6.91C48 7.119 53.735 0 63.64 0h32.53C106.1 0 112 7.186 112 17.21V24h32c8.837 0 16 7.163 16 16v80c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V40c0-8.837 7.163-16 16-16h32zm8 0h48v-6.79c0-5.915-2.705-9.21-7.83-9.21H63.64C58.58 8 56 11.202 56 17.09V24zM40 80v12a4 4 0 11-8 0V80H20a19.911 19.911 0 01-12-3.999V120a8 8 0 008 8h128a8 8 0 008-8V76.001A19.911 19.911 0 01140 80h-12v12a4 4 0 11-8 0V80H40zm0-8h80V60a4 4 0 118 0v12h12c6.627 0 12-5.373 12-12V40a8 8 0 00-8-8H16a8 8 0 00-8 8v20c0 6.627 5.373 12 12 12h12V60a4 4 0 118 0v12z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const CompletedCircle = () => (
  <svg viewBox="0 0 28 28">
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M24.943 4.781a.667.667 0 01.943.943L12.474 19.136a.667.667 0 01-.943 0l-5.96-5.962a.667.667 0 11.943-.943l5.489 5.49 12.94-12.94zm-.038 5.373a.667.667 0 011.286-.353 13.333 13.333 0 11-4.234-6.637.667.667 0 11-.862 1.017 12 12 0 103.81 5.973z"
        transform="translate(.667 .667)"
      />
    </g>
  </svg>
);

const CanceledCircle = () => (
  <svg viewBox="0 0 160 160">
    <path
      fill="currentColor"
      d="M23.456 136.593a4.046 4.046 0 01-.049-.05C-7.81 105.3-7.803 54.666 23.432 23.432c31.241-31.242 81.895-31.242 113.136 0 31.242 31.242 31.242 81.896 0 113.137-31.233 31.234-81.868 31.242-113.112.025zm2.881-8.587L128.006 26.337C99.736 1.003 56.257 1.92 29.088 29.088 1.92 56.257 1.003 99.736 26.338 128.006zm107.326-96.012L31.994 133.663c28.27 25.334 71.749 24.417 98.918-2.752 27.168-27.168 28.085-70.647 2.75-98.917z"
      fillRule="evenodd"
    />
  </svg>
);

const FiltersIcon = () => (
  <svg viewBox="0 0 21 21">
    <path
      d="M7.5 15a2.5 2.5 0 012.45 2h9.6a.5.5 0 110 1h-9.6a2.5 2.5 0 01-4.9 0H.5a.5.5 0 110-1h4.55a2.5 2.5 0 012.45-2zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM14 7.5a2.5 2.5 0 012.45 2h3.1a.5.5 0 110 1h-3.1a2.5 2.5 0 01-4.9 0H.5a.5.5 0 110-1h11.05a2.5 2.5 0 012.45-2zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM7.5 0a2.5 2.5 0 012.45 2h9.6a.5.5 0 110 1h-9.6a2.5 2.5 0 01-4.9 0H.5a.5.5 0 010-1h4.55A2.5 2.5 0 017.5 0zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const RefreshIcon = () => (
  <svg viewBox="0 0 20 18">
    <path
      d="M8.217.815a8.204 8.204 0 00-.014 16.407.5.5 0 00.001-1 7.204 7.204 0 117.213-7.203l.001 2.404-2.837-2.719a.5.5 0 00-.639-.044l-.068.059a.5.5 0 00.015.707l3.682 3.531a.5.5 0 00.697-.005l3.583-3.53a.5.5 0 10-.702-.713L16.418 11.4V9.019a8.204 8.204 0 00-7.95-8.2z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const SpeachMark = () => (
  <svg viewBox="0 0 24 23">
    <g fill="none" fillRule="evenodd">
      <path
        d="M3.644 15.118a10.261 10.261 0 001.978 1.535 1.717 1.717 0 01.755 1.452c-.035.9-.412 1.83-1.125 2.774a9.973 9.973 0 001.607-.322c.695-.2 1.371-.473 2.01-.812.532-.277 1.05-.583 1.544-.913.272-.215.611-.326.957-.312H11.648c1.47.1 2.934-.047 4.355-.434a10.95 10.95 0 003.547-1.672 9.553 9.553 0 002.37-2.603c.558-.977.88-2.087.93-3.21a7.422 7.422 0 00-.656-3.315 8.787 8.787 0 00-2.134-2.937 11.846 11.846 0 00-3.373-2.164 13.234 13.234 0 00-8.61-.58l-.336.084a.624.624 0 01-.164.068 14.242 14.242 0 00-4.02 2.347 6.713 6.713 0 00-1.403 1.834 6.85 6.85 0 00-.792 5.3c.183.707.466 1.383.841 2.01.425.66.91 1.29 1.441 1.87zm.294 6.963a.572.572 0 01-.403-.976c1.088-1.086 1.66-2.107 1.7-3.033a.576.576 0 00-.244-.466 11.419 11.419 0 01-2.18-1.706 15.133 15.133 0 01-1.583-2.057 8.781 8.781 0 01-.972-2.317 8 8 0 01.914-6.17 7.856 7.856 0 011.646-2.122A15.385 15.385 0 017.176.687a.625.625 0 01.24-.095l.371-.093c3.076-.839 6.4-.615 9.346.633a12.984 12.984 0 013.695 2.372 9.92 9.92 0 012.408 3.311 8.573 8.573 0 01.756 3.832 8.315 8.315 0 01-1.085 3.74l-.01.016a10.69 10.69 0 01-2.665 2.927l-.012.009a12.086 12.086 0 01-3.92 1.85c-1.534.418-3.12.577-4.709.473h-.261a.312.312 0 00-.214.071.561.561 0 01-.046.034c-.536.36-1.097.692-1.67.99-.704.374-1.454.677-2.225.899a11.143 11.143 0 01-2.682.425h-.555z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const SpeachMarkFilled = () => (
  <svg viewBox="0 0 24 23">
    <path
      d="M3.938 22.08a.572.572 0 01-.403-.975c1.088-1.086 1.66-2.107 1.7-3.033a.576.576 0 00-.244-.466 11.413 11.413 0 01-2.18-1.706c-.58-.633-1.11-1.32-1.574-2.042l-.01-.015a8.785 8.785 0 01-.971-2.317 8 8 0 01.914-6.17 7.851 7.851 0 011.646-2.122A15.385 15.385 0 017.176.686a.622.622 0 01.24-.094l.371-.093c3.076-.839 6.4-.615 9.346.633a12.978 12.978 0 013.695 2.372 9.92 9.92 0 012.408 3.311 8.574 8.574 0 01.756 3.832 8.315 8.315 0 01-1.085 3.74l-.01.016a10.692 10.692 0 01-2.677 2.936 12.08 12.08 0 01-3.92 1.85 14.35 14.35 0 01-4.709.473h-.261a.314.314 0 00-.214.071.53.53 0 01-.046.034c-.536.359-1.097.692-1.67.99-.704.374-1.454.677-2.225.898a11.15 11.15 0 01-2.682.426h-.555z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const EnvelopMark = () => (
  <svg viewBox="0 0 1024 1024" width="22" height="22">
    <path
      d="M909.3 184.2h-796c-21 0-38 17-38 38v589.9c0 21 17 38 38 38h796c21 0 38-17 38-38V222.2c0-21-17-38-38-38zm-102.6 72L540.3 522.6c-12.8 12.8-33.6 12.8-46.4 0L227.5 256.2h579.2zM147.3 778.1V277.9L443 573.5c20.4 20.4 47.3 30.7 74.1 30.7 26.8 0 53.7-10.2 74.1-30.7l284.1-284.1v488.8h-728z"
      fill="#8F8F8F"
    />
  </svg>
);

const CircleQuestionMark = () => (
  <svg
    viewBox="0 0 1024 1024"
    width={36}
    height={36}
  >
    <path
      d="M507.814 127.998q-154.182 0-263.273 109.091Q135.45 346.18 135.45 500.362q0 154.182 109.091 263.273 109.091 109.091 263.273 109.091 154.182 0 263.273-109.091 109.091-109.091 109.091-263.273 0-154.182-109.091-263.273-109.091-109.091-263.273-109.091zm0 714.909q-69.818 0-133.091-26.909-63.273-27.636-109.091-73.455-45.818-45.818-73.455-109.091-26.909-63.273-26.909-133.091 0-69.818 26.909-133.091 27.636-63.273 73.455-109.091 45.818-45.818 109.091-73.455 63.273-26.909 133.091-26.909 69.818 0 133.091 26.909 63.273 27.636 109.091 73.455 45.818 45.818 73.455 109.091 26.909 63.273 26.909 133.091 0 69.818-26.909 133.091-27.636 63.273-73.455 109.091-45.818 45.818-109.091 73.455-63.273 26.909-133.091 26.909zm2.181-182.545q-13.091 0-21.818 8.727-8.727 9.455-8.727 22.545 0 13.091 8.727 21.818 8.727 8.727 21.818 8.727 13.091 0 22.545-8.727 8.727-8.727 8.727-21.818 0-13.091-8.727-22.545-9.455-8.727-22.545-8.727zm-2.181-381.819q-47.273 0-81.455 32.727-34.182 33.455-34.182 81.455 0 9.455 6.545 16 7.273 7.273 17.455 7.273 9.455 0 16-7.273 7.273-6.545 7.273-16 0-29.091 19.636-48.727 20.364-19.636 50.182-19.636 28.364 0 48.727 20.364 20.364 20.364 20.364 48.727 0 7.273-6.545 16.727-6.545 10.182-13.091 17.455-5.818 6.545-18.909 19.636-16.727 16.727-26.182 26.909-8.727 10.182-18.909 29.091-9.455 18.182-9.455 35.636v53.091q0 9.455 6.545 16.727 7.273 7.273 17.455 7.273 9.455 0 16-6.545 7.273-7.273 7.273-17.455v-53.091q0-8.727 6.545-20.364 7.273-10.909 13.818-18.182 7.273-8 20.364-21.091 16.727-16.727 25.455-26.182 8.727-9.455 16.727-26.182 8.727-17.455 8.727-33.455-.727-48-34.909-81.455t-81.455-33.455z"
      fill="#656565"
    />
  </svg>
);

const CloneIcone = () => (
  <svg
    height={16}
    viewBox="0 0 1792 1792"
    width={16}
  >
    <path
      d="M1664 1632v-1088q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5v1088q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5zm128-1088v1088q0 66-47 113t-113 47h-1088q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1088q66 0 113 47t47 113zm-384-384v160h-128v-160q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5v1088q0 13 9.5 22.5t22.5 9.5h160v128h-160q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1088q66 0 113 47t47 113z"
      fill="#8f8d8d"
    />
  </svg>
);

export {
  HouseSvg,
  PaperSvg,
  FileXLS,
  FilePDF,
  CirclePlus,
  CirclePlusOutline,
  CircleCross,
  ChevronDown,
  ChevronLargeUp,
  ChevronLargeDown,
  ChevronUp,
  ChevronIconLeft,
  DoubleChevronIconLeft,
  DoubleChevronIconRight,
  ChevronIconRight,
  ChevronFilledDown,
  ChevronFilledUp,
  ChevronFilledRight,
  ChevronFilledLeft,
  VodafoneLogo,
  SearchMagnifier,
  SilhouetteAvatar,
  SilhouetteAvatarWithAFriend,
  WarningCircle,
  WarningTriangle,
  WarningTriangleFilled,
  CrossSvg,
  TickSvg,
  CalenderSvg,
  ClockSvg,
  ClockLoadingSvg,
  ExpandAll,
  CollapseAll,
  InformationCircle,
  LoadingSpinnerSVG,
  CheckBoxUnchecked,
  CheckBoxChecked,
  DownloadIcon,
  Pencil,
  WritingPencil,
  Briefcase,
  CompletedCircle,
  CanceledCircle,
  FiltersIcon,
  RefreshIcon,
  SpeachMark,
  SpeachMarkFilled,
  EnvelopMark,
  CircleQuestionMark,
  CloneIcone,
};

